<div class="ion-margin-horizontal ql-container">
  <div
    class="ql-editor"
    [innerHTML]="content"
  ></div>
</div>
